<app-spinner-service></app-spinner-service>

<p-toolbar>
  <div class="p-toolbar-group-left">
  </div>
  <div class="p-toolbar-group-right">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input pInputText type="text" (input)="applyFilterGlobal($event, 'contains')" placeholder="Pesquisar" />
    </span>
  </div>
</p-toolbar>

<p-confirmDialog></p-confirmDialog>

<p-table #dt [value]="receitasBrutasAnteriores" [paginator]="true" [rows]="10"
  [globalFilterFields]="['periodoApuracao', 'valorInterno', 'valorExterno']">

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="periodoApuracao">Competência</th>
      <th pSortableColumn="valorInterno">Receita Mercado Interno</th>
      <th pSortableColumn="valorExterno">Receita Mercado Externo</th>
      <th>Ações</th> 
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-receitaBrutaAnterior>
    <tr>
      <td>{{ formatCompetencia(receitaBrutaAnterior.periodoApuracao) }}</td>
      <td>{{ receitaBrutaAnterior.valorInterno | currency:'BRL' : 'symbol' : '1.2-2' }}</td>
      <td>{{ receitaBrutaAnterior.valorExterno | currency:'BRL' : 'symbol' : '1.2-2' }}</td>
      <td>
        <button pButton pRipple icon="pi pi-pencil"
          pTooltip="Editar Receita" tooltipPosition="left" class="mr-2 p-button-rounded"
          (click)="adicionarReceita(receitaBrutaAnterior.id)">
        </button>
        <button pButton icon="pi pi-trash" class="p-button-rounded p-button-danger mr-2"
          pTooltip="Excluir Receita" tooltipPosition="left" 
          (click)="deleteReceita(receitaBrutaAnterior)">
        </button>
      </td>
    </tr>
  </ng-template>
</p-table>
